export default function () {
    return {
        events: [],
        calendars: [],
        extraCalendars: [],
        skipBlockingAlert: false,
        showBlockingAlert: false,
        datesToBlock: [],
        currentBlockingCalendar: null,
        calendarPanels: {}
    }
}
